module.exports = __webpack_public_path__ + "static/media/story-bg.e844778.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/video/story-bg.mp4
// module id = 050h
// module chunks = 1 3